module.exports = __webpack_public_path__ + "img/14-f6d59e.png";